// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"02cef7bf","223":"f92418b1"}[chunkId] + ".chunk.js";
};